import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import uuidv1 from 'uuid/v1';
import PropTypes from 'prop-types';

import Node from './Node';
import Banner from '../ui/Banner';
import './styles/CollapsibleTree.scss';

export class CollapsibleTreeClass extends React.Component {
	shouldComponentUpdate(nextProps) {
		// Only update when we change the selectedList or we are past
		// the first load. Need this to pre-check the top-level acct.
		return !(this.props.selectedList.id === nextProps.selectedList.id)
			|| nextProps.selectedList.isFirstLoad
			// or if we were waiting on the tree data to load and we already chose a list
			|| this.props.treeIsLoaded !== nextProps.treeIsLoaded
			// or we're filtering the list
			|| this.props.isFiltering !== nextProps.isFiltering;
	}

	render() {
		const { tree, addRemoveItem, checkForEmptyList, i18n } = this.props;
		return (
			<div>
				<Banner />
				<div id="tree_container">
					<ul key={uuidv1()}>
						<Node
							node={tree.root}
							key={'root'}
							keyVal={'root'}
							allDescendants={tree.root.value.descendantAccountIds}
							children={tree.root.children} // eslint-disable-line react/no-children-prop
							addRemoveItem={(id, isAdding) => {addRemoveItem(id, isAdding)}}
							checkForEmptyList={checkForEmptyList}
							isRootNode  // Start with root node open
							i18n={i18n}
						/>
					</ul>
				</div>
			</div>
		);
	}
}

CollapsibleTreeClass.propTypes = {
	tree: PropTypes.shape({}).isRequired,
	addRemoveItem: PropTypes.func.isRequired,
	checkForEmptyList: PropTypes.func.isRequired,
	i18n: PropTypes.shape({}).isRequired,
	selectedList: PropTypes.shape({
		id: PropTypes.string.isRequired,
	}).isRequired,
	treeIsLoaded: PropTypes.bool.isRequired,
	isFiltering: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
	selectedList: state.selectedList,
	treeIsLoaded: state.treeIsLoaded,
	isFiltering: state.isFiltering,
});

const CollapsibleTree = connect(
	mapStateToProps
)(CollapsibleTreeClass);

export default withTranslation()(CollapsibleTree);
